module.exports = __webpack_public_path__ + "static/media/epl.d31051df.png";